import { checkDomainAvailability as checkAvailability } from '@wix/ambassador-premium-domains-v2-availability/http';
import { createHttpClient } from '@wix/http-client';

const httpClient = createHttpClient({});

const checkDomainAvailability = async (domain: string) => {
  const response = await httpClient.request(checkAvailability({ domain }));
  return response.data;
};

export const domainApi = {
  checkDomainAvailability,
};
